<div class="user-panel">
  @if (account(); as account) {
    <button class="user-button" matIconButton [matMenuTriggerFor]="userMenu">
        <span class="avatar">
          {{ account.initials }}
        </span>
    </button>
  }

  <button class="language-button" matIconButton [matMenuTriggerFor]="languageMenu">
    <span class="language-text">
      @if (selectedLanguage | async; as lang) {
        <app-flag [language]="lang"></app-flag>
      }
    </span>
  </button>
</div>

<mat-menu #languageMenu="matMenu">
  @for (lang of languages; track lang) {
    <button class="language-menu-button" mat-menu-item (click)="changeLanguage(lang)">
      <app-flag [language]="lang" [withLangText]="true"></app-flag>
    </button>
  }
</mat-menu>

<mat-menu #userMenu="matMenu">
  @if (account(); as account) {
    <div class="user-menu-info">
      {{ account.user.username }}
    </div>
  }
  <button mat-menu-item (click)="logout()">{{ "header.logout" | translate }}</button>
</mat-menu>
